export const YesIcon = () => (
  <svg
    width="21"
    height="17"
    viewBox="0 0 21 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 12.2942L5.56426 15.7177C5.85559 15.9362 6.22006 16.0336 6.58153 15.9897C6.943 15.9457 7.27352 15.7638 7.50404 15.482L19.3531 1"
      stroke="#00FF75"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
